import { get } from 'lodash';

import { SUPPORTED_LOCALES } from 'constants/locales';
import Model from 'models';
import Settings from 'utils/Settings';

const StoryCardModel = class extends Model {
  localizedValue(field) {
    return get(
      this._data,
      [field, Settings.currentLocale],
      get(this._data, [field, SUPPORTED_LOCALES.EN_US])
    );
  }

  get paragraph() {
    return this.localizedValue('localizedParagraph');
  }

  get headline() {
    return this.localizedValue('localizedHeadline');
  }

  get header() {
    return this.localizedValue('localizedHeader');
  }

  get textColor() {
    return this.localizedValue('localizedTextColor')?.toLowerCase?.();
  }

  get backgroundImagePortrait() {
    return this.localizedValue('localizedBackgroundImagePortrait');
  }

  get backgroundImageLandscape() {
    return this.localizedValue('localizedBackgroundImageLandscape');
  }

  get icon() {
    return this.localizedValue('localizedIconImage');
  }

  get backgroundColor() {
    return get(this._data, 'backgroundColor');
  }

  get ctaLinks() {
    return get(this._data, 'localizedCtaLinks', []).map(ctaLink => ({
      label: get(
        ctaLink,
        ['label', Settings.currentLocale],
        get(ctaLink, ['label', SUPPORTED_LOCALES.EN_US])
      ),
      url: get(
        ctaLink,
        ['url', Settings.currentLocale],
        get(ctaLink, ['url', SUPPORTED_LOCALES.EN_US])
      ),
    }));
  }
};

export default StoryCardModel;
